export enum MATCH_STATUS {
    LIVE = 0,
    WAITING = 1,
    FINISH = 2,
    CANCEL = 3,
}

export interface ITabItem<T> {
    renderedValue: T;
    value: string;
}

export interface ITeam {
    id: number;
    link: string;
    name: string;
    nameVN: string;
    logo: string;
    profiles: { name: string; value: string }[];
    completitions: ICompetition[];
}

export interface ITeamDetail extends ITeam {
    tabs?: ISoccerTab[];
    activeTabIndex?: number;
}

export interface IMatchTeam {
    team: ITeam;
    scored: number;
    scoredNote: string;
    coacheId: number;
    coachName: string;
}

export interface ICompetition {
    continentId?: number;
    countryId?: number;
    id: number;
    link: string;
    logo: string;
    name: string;
    alias: string;
    seasonId?: number;
    shortName: string;
}

export interface ICompetitionDetail extends ICompetition {
    tabs?: ISoccerTab[];
    activeTabIndex?: number;
}

export interface IMatch {
    id: number;
    link: string;
    countryID: number;
    countryName?: string;
    competition: ICompetition;
    competitionId: number;
    groupId: number;
    groupName: string;
    startTime: number;
    date: string;
    time: string;
    matchStatus: MATCH_STATUS;
    venue?: string;
    home: IMatchTeam;
    away: IMatchTeam;
}

export type TMatchStats = {
    name: STATS_TYPE;
    home: number;
    away: number;
};

export enum STATS_TYPE {
    POSSESSION = 'Possession',
    GOALS = 'Goals',
    CORNERS = 'Corners',
    SHORTS = 'Shots on target',
    SHOT_WIDE = 'Shots wide',
    FOULS = 'Fouls',
    OFFSIDES = 'Offsides',
}

export type TTeam = 'home' | 'away';

export enum INCIDENT_TYPE {
    GOAL = 'goal',
    OWN_GOAL = 'own_goal',
    YELLOW = 'card_yellow',
    YELLOW_SECOND = 'card_yellow_2nd',
    SUB = 'substituted',
    RED = 'card_red',
}

export type TIncident = {
    type: INCIDENT_TYPE;
    minute: number;
    content: string;
    team: TTeam;
    subType?: string;
};

export type TIncidents = TIncident[];

export type TMatchEvent = {
    minute: string;
    content: TIncidents;
};

export interface IPenalty {
    certainScore: string;
    team: TTeam;
    playerId: number;
    playerName: string;
    success: string;
}

export type TGoal = {
    playerName: string;
    instantScore: string;
    team: TTeam;
    minute: string;
};

export interface IPlayer {
    id: number;
    name: string;
    number: number;
}

export type TMatchPlayer = {
    player: IPlayer;
    isSubstituted: string;
    team: TTeam;
    incidents?: TIncidents;
    substForID: string;
    substForName: string;
    substMinute: string;
};

export interface IMatchDetail extends IMatch {
    events: TMatchEvent[];
    goals: TGoal[];
    lineups: TMatchPlayer[];
    substs: TMatchPlayer[];
    stats: TMatchStats[];
    penalties?: IPenalty[];
    tabs?: ISoccerTab[];
    embedVideoUrl?: string;
    activeTabIndex?: number;
}

export interface IStanding {
    team: ITeam;
    groupName: string;
    groupId: number;
    rank: number;
    wins: number;
    draws: number;
    loses: number;
    goalsScored: number;
    goalsAgainst: number;
    goalsDifference: number;
    points: number;
    stageName: string;
}

export interface ISoccerTab {
    id: string;
    name: string;
    url?: string;
    options: any;
}
